import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Teleport as _Teleport, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/pictures/appstore/Apple_App_Store.png'
import _imports_1 from '../../../assets/pictures/appstore/Google_Play_Store.png'


const _withScopeId = n => (_pushScopeId("data-v-b1fa7308"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card_text_and_image_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("iframe", {
  width: "100%",
  style: {"aspect-ratio":"16/9"},
  src: "https://www.youtube.com/embed/_s_AhIqxR-M?si=6JRoicb4bQ6PdPq6",
  title: "YouTube video player",
  frameborder: "0",
  allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
  allowfullscreen: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "appstore-icons" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
], -1))
const _hoisted_4 = { class: "card_text_and_image_wrapper" }
const _hoisted_5 = { class: "passguide-card-content-wrapper" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Börja med att öppna appen och trycka på Add your pass. Ange ditt efternamn och biljettnummer. Du hittar biljettnummret i konfirmationsmailet vi skickade till dig efter din bokning. Efter att biljetten är aktiverad hittar du den under My Pass. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Reser ni som en grupp?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Du kan lägga till flera biljetter i samma app. Men kom ihåg att du inte kan flytta en biljett mellan olika enheter om biljetten är aktiverad. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Reser ni med barn"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" En barnbiljett skall vara tillaggd på samma enhet som minst en vuxenbiljett. ")
], -1))
const _hoisted_7 = { class: "passguide-card-content-wrapper" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Anslut en resa till din biljett. Med hjälp av resan kan du hålla full koll på hur du skall åka. Du kan skapa en ny resa eller välja en redan skapad resa och koppla ihop den med din biljett. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Mer än en biljett på din enhet?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Varje biljett behöver sin egen resa. Du kan dupplicera en resa för att koppla din till flera biljetter på samma enhet. ")
], -1))
const _hoisted_9 = { class: "passguide-card-content-wrapper" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Innan du åker iväg måste du aktivera din biljett så det är redo att användas. För att göra detta behöver du ditt pass eller ID och du behöver veta vilket datum du planerar att påbörja din resa. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Är du inte säker på vart du börjar din resa?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Du behöver inte oroa dig. Du kan göra detta steget senare. Det går att aktivera en biljett ända fram tills ditt första resedatum. Men kom ihåg att du kan inte gå på ett tåg utan ett aktiverad biljett. Ett pass behöver aktiveras max 11 månader efter köpdatum. ")
], -1))

import TextBlock from "../../blocks/TextBlock.vue";
import ContentWrapper from "../../generics/ContentWrapper.vue";
import PageTitle from "../../blocks/PageTitle.vue";
import CustomCard from "../../generics/CustomCard.vue";
import CustomPic from "../../generics/CustomPic.vue";
import meta from "@/data/meta.json";

export default /*#__PURE__*/_defineComponent({
  __name: 'MobilePass',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent('script'), { type: "application/ld+json" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(meta).mobilePass), 1)
        ]),
        _: 1
      }))
    ])),
    _createVNode(PageTitle, {
      text: "Hur du installerar ditt mobila pass",
      backgroundImageClass: "background-champs-elysees"
    }),
    _createVNode(ContentWrapper, null, {
      default: _withCtx(() => [
        _createVNode(TextBlock, {
          "header-tag": "h2",
          header: "\nKolla på den här videon om du föredrar att få din förklaring via video. Under videon hittar du en text som beskriver hur Interrails digitala biljettsystem fungerar."
        }),
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createVNode(TextBlock, {
            header: "Ladda ner railplanner appen",
            content: "Innan du börjar rekomenderar vi att du laddar ner den senaste versionen av Rail Planner Appen. Du kommer behöva en internetanslutning för vissa funktioner i appen så ta det i beaktning när du är på resande fot. Appen är supportad för Android 6.0 och senare, samt iOS 13.0 och senare."
          }),
          _hoisted_3
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(TextBlock, {
            header: "Aktivera ditt pass i appen",
            content: "Få ditt Mobile Pass redo med tre enkla steg. Följ guiden för att aktivera din biljett."
          }),
          _createVNode(CustomCard, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(CustomPic, {
                  picturePath: "pictures/passguide/step1.png",
                  auto: true
                }),
                _createVNode(TextBlock, {
                  class: "textblock",
                  header: "Steg 1: Lägg till din biljett"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(CustomCard, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(CustomPic, {
                  picturePath: "pictures/passguide/step2.png",
                  auto: true
                }),
                _createVNode(TextBlock, {
                  class: "textblock",
                  header: "Steg 2: Anslut en resa"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(CustomCard, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(CustomPic, {
                  picturePath: "pictures/passguide/step3.png",
                  auto: true
                }),
                _createVNode(TextBlock, {
                  class: "textblock",
                  header: "Steg 3: Aktivera din biljett"
                }, {
                  default: _withCtx(() => [
                    _hoisted_10
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})